import React, {Fragment} from "react";
import Source from "./From/Source";
import Customer from "./To/Customer";
import Comment from "./Comment";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import Buttons from "./Buttons";
import List from './List';
import Shipping from "./Shipping";
import Invoice from "./Invoice";
import Payment from "./Payment";

class PurchaseReturnForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Editor
                theme="default"
                body={
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <Source {...componentProps} />
                            </div>
                            <div className="col-md-6">
                                <Customer {...componentProps} />
                            </div>
                        </div>
                        <div className="row form-row">
                            <Invoice {...componentProps} changeActing={true} TabsByName={true} swapTabs={true}/>
                        </div>
                        <div className="row form-row">
                            <Payment {...componentProps} />
                        </div>
                        <div className="row form-row">
                            <Shipping {...componentProps} />
                        </div>
                        <Comment {...componentProps} />
                        <PoolList {...componentProps} control={{visible: false}}/>
                    </form>
                }
                footer={<Fragment>
                    <Buttons {...componentProps} />
                </Fragment>}
            />
        </Fragment>;
    }
}


export default PurchaseReturnForm;